<ngx-spinner size="medium" color="#007bff" size="medium" type="ball-spin-clockwise-fade"></ngx-spinner>
<app-sidebar *ngIf="service.isLoggedIn()"></app-sidebar>
<router-outlet></router-outlet>
<app-footer></app-footer>